import { initMetrika } from "@/services/initMetrika";

export const applyCookieConsent = () => {
  const consent = localStorage.getItem("cookie_consent");

  if (consent === "all") {
    initMetrika();

    if (!document.getElementById("google-analytics-script")) {
      const script = document.createElement("script");
      script.id = "google-analytics-script";
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-M4V7GZ7TWB";
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];

      window.gtag = function () {
        window.dataLayer.push(arguments);
      };

      window.gtag("js", new Date());
      window.gtag("config", "G-M4V7GZ7TWB");
    }
  }
};
